// Import Firebase SDK
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDT7auT3EHLUJZt8iJdJ1FJ0wZXnLhaZhc",
  authDomain: "athar-advisory.firebaseapp.com",
  projectId: "athar-advisory",
  storageBucket: "athar-advisory.appspot.com", // ✅ fix .app to .appspot.com
  messagingSenderId: "569138732424",
  appId: "1:569138732424:web:99506c8017d820ba736e3d",
  measurementId: "G-VP9K5WNVJM"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Initialize and export services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
